export default [
  {
    title: 'breadcrumb.master',
    route: 'list-master',
    icon: 'UserIcon',
    resource: 'master',
    action: 'read',
  },
]
